import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';

import { Typography } from '../Typography';

import styles from './Tooltip.module.scss';

export interface ITooltipProps extends RadixTooltip.TooltipProps {
    children: React.ReactNode;
    content: React.ReactNode;
    disabled?: boolean;
    contentProps?: RadixTooltip.TooltipContentProps;
}

export const Tooltip: React.FC<ITooltipProps> = ({ children, content, disabled, contentProps, ...props }) => {
    if (disabled) return <>{children}</>;

    return (
        <RadixTooltip.Provider>
            <RadixTooltip.Root delayDuration={100} {...props}>
                <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
                <RadixTooltip.Portal>
                    <RadixTooltip.Content className={styles.content} sideOffset={4} {...contentProps}>
                        <Typography variant="base12" color="white">
                            {content}
                        </Typography>
                        <RadixTooltip.Arrow className={styles.arrow} />
                    </RadixTooltip.Content>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    );
};
